"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSnapshot = exports.TableSnapshotter = exports.GameSnapshotter = exports.Snapshot = void 0;
const class_transformer_1 = require("class-transformer");
const __1 = require("../");
const util_1 = require("../util");
const _1 = require("./");
const ActionEvaluator_1 = require("./ActionEvaluator");
const Bet_1 = require("./Bet");
const BettingRecommender_1 = require("./BettingRecommender");
const Blind_1 = require("./Blind");
const Pot_1 = require("./Pot");
class TableSnapshot {
}
__decorate([
    class_transformer_1.Type(() => __1.GameStates),
    __metadata("design:type", Object)
], TableSnapshot.prototype, "state", void 0);
__decorate([
    class_transformer_1.Type(() => String),
    __metadata("design:type", Array)
], TableSnapshot.prototype, "communityCards", void 0);
__decorate([
    class_transformer_1.Type(() => Pot_1.Pot),
    __metadata("design:type", Array)
], TableSnapshot.prototype, "sidePots", void 0);
__decorate([
    class_transformer_1.Type(() => Pot_1.PotWinner),
    __metadata("design:type", Array)
], TableSnapshot.prototype, "winners", void 0);
__decorate([
    class_transformer_1.Type(() => BettingRecommender_1.BetHint),
    __metadata("design:type", Array)
], TableSnapshot.prototype, "betHints", void 0);
__decorate([
    class_transformer_1.Type(() => Bet_1.Bet),
    __metadata("design:type", Bet_1.Bet)
], TableSnapshot.prototype, "lastBet", void 0);
__decorate([
    class_transformer_1.Type(() => Blind_1.Blind),
    __metadata("design:type", Blind_1.Blind)
], TableSnapshot.prototype, "blinds", void 0);
exports.TableSnapshot = TableSnapshot;
class Snapshot {
}
__decorate([
    class_transformer_1.Type(() => __1.GameStates),
    __metadata("design:type", Object)
], Snapshot.prototype, "gameState", void 0);
__decorate([
    class_transformer_1.Type(() => TableSnapshot),
    __metadata("design:type", Object)
], Snapshot.prototype, "table", void 0);
__decorate([
    class_transformer_1.Type(() => _1.Player),
    __metadata("design:type", Array)
], Snapshot.prototype, "players", void 0);
__decorate([
    class_transformer_1.Type(() => _1.Player),
    __metadata("design:type", _1.Player)
], Snapshot.prototype, "forPlayer", void 0);
__decorate([
    class_transformer_1.Type(() => Bet_1.Bet),
    __metadata("design:type", Bet_1.Bet)
], Snapshot.prototype, "withBet", void 0);
exports.Snapshot = Snapshot;
class GameSnapshotter {
    constructor(game) {
        this.game = game;
        return this;
    }
    snapshot() {
        return new TableSnapshotter(this.game.defaultTable).snapshot();
    }
    snapshotForPlayer(playerId) {
        return new TableSnapshotter(this.game.defaultTable).snapshotForPlayer(playerId);
    }
    static forGame(game) {
        return new GameSnapshotter(game).snapshot();
    }
    static forGamePlayer(game, playerId) {
        return new GameSnapshotter(game).snapshotForPlayer(playerId);
    }
}
exports.GameSnapshotter = GameSnapshotter;
class TableSnapshotter {
    constructor(table) {
        this.table = table;
        return this;
    }
    snapshot() {
        let [table, players] = [this.table, this.table.players];
        players = this.table.players.map((player) => {
            return Object.assign(Object.assign({}, class_transformer_1.classToPlain(player)), { events: [] });
        });
        const tableSnap = { 0: this.snapshotForTable(table) };
        return {
            gameId: table.gameId,
            gameName: table.gameName,
            gameState: table.state,
            table: tableSnap,
            players,
            forPlayer: undefined,
            currentPlayerAction: [],
        };
    }
    snapshotForPlayer(playerId) {
        let [table, players] = [this.table, this.table.players];
        players = this.table.players.map((player) => {
            return Object.assign(Object.assign({}, class_transformer_1.classToPlain(player)), { events: [] });
        });
        const forPlayer = Object.assign(Object.assign({}, class_transformer_1.classToPlain(table.getPlayerById(playerId))), { events: [] });
        let currentPlayerAction = forPlayer === null || forPlayer === void 0 ? void 0 : forPlayer.actions;
        if ((forPlayer === null || forPlayer === void 0 ? void 0 : forPlayer.actions.length) === 0) {
            currentPlayerAction = ActionEvaluator_1.ActionEvaluator.getActionHints(table.board, table.getPlayerById(forPlayer === null || forPlayer === void 0 ? void 0 : forPlayer.id), table.getBigBlindPlayer());
        }
        return {
            gameId: table.gameId,
            gameName: table.gameName,
            gameState: table.state,
            table: { 0: this.snapshotForTable(table) },
            players,
            forPlayer,
            currentPlayerAction,
        };
    }
    snapshotForPlayerWithBet(playerId, bet) {
        const snapshot = this.snapshotForPlayer(playerId);
        snapshot.withBet = bet;
        return snapshot;
    }
    snapshotForTable(table) {
        const board = table.board;
        const predeal = board.isPreDeal();
        const communityCards = board.isFlop()
            ? board.communityCards.slice(0, 3)
            : board.isTurn()
                ? board.communityCards.slice(0, 4)
                : board.communityCards;
        return {
            id: table.getId(),
            name: table.name,
            bigBlindPlayer: predeal
                ? 0
                : table.getBigBlindPlayer()
                    ? table.getBigBlindPlayerIndex()
                    : 0,
            bigBlindPlayerId: predeal
                ? 0
                : table.getBigBlindPlayer()
                    ? table.getBigBlindPlayer().getId()
                    : 0,
            buttonPlayer: predeal ? -1 : table.getButtonPlayerIndex(),
            buttonPlayerId: predeal
                ? 0
                : table.getButtonPlayer()
                    ? table.getButtonPlayer().getId()
                    : 0,
            currentPlayer: predeal ? 0 : table.getCurrentPlayerIndex(),
            currentPlayerId: predeal
                ? 0
                : table.getCurrentPlayer()
                    ? table.getCurrentPlayer().getId()
                    : 0,
            smallBlindPlayer: predeal
                ? 0
                : table.getSmallBlindPlayer()
                    ? table.getSmallBlindPlayerIndex()
                    : 0,
            smallBlindPlayerId: predeal
                ? 0
                : table.getSmallBlindPlayer()
                    ? table.getSmallBlindPlayer().getId()
                    : 0,
            minPlayers: table.minPlayers,
            maxPlayers: table.maxPlayers,
            tableState: table.internalState().tag,
            state: table.internalState(),
            communityCards,
            mainPot: TableSnapshotter.getMainPotValue(board),
            sidePots: TableSnapshotter.getSidePots(board),
            bigBlindAmount: board.blinds.big,
            smallBlindAmount: board.blinds.small,
            biggestBet: board.biggestBet(),
            boardState: board.internalState(),
            winners: TableSnapshotter.getWinnersFromPots(board),
            betHints: BettingRecommender_1.BettingRecommender.getBetHints(board),
            checkpoint: table.getCheckpoint(),
            lastBet: table.lastBet,
            lastPlayerAction: table.lastPlayerAction,
            isFlop: board.isFlop(),
            isTurn: board.isTurn(),
            isRiver: board.isRiver(),
            minimumRaise: table.getMinimumRaise(),
            nextBlinds: table.nextBlinds,
            blindTimerCheckpoint: table.blindTimerCheckpoint,
            blinds: table.blinds,
            gameStartTime: table.gameStartTime,
            nextBlindIndex: table.nextBlindIndex,
            gamePauseTime: table.gamePauseTime,
        };
    }
    static forTable(table) {
        return new TableSnapshotter(table).snapshot();
    }
    static forPlayer(table, playerId) {
        return new TableSnapshotter(table).snapshotForPlayer(playerId);
    }
    static forPlayerWithBet(table, playerId, bet) {
        return new TableSnapshotter(table).snapshotForPlayerWithBet(playerId, bet);
    }
    static getWinnersFromPots(board) {
        return board.getAllPots().reduce((winners, pot) => {
            if (pot.winners) {
                winners = winners.concat(pot.winners);
            }
            return winners;
        }, []);
    }
    static getSidePots(board) {
        const sidePots = board
            .getAllPots()
            .filter((pot) => pot.kind === Pot_1.PotKind.SIDE);
        util_1.logger.trace(`getSidePots: ${JSON.stringify(sidePots)}`);
        return sidePots;
    }
    static getMainPotValue(board) {
        return board.pot.amount;
    }
}
exports.TableSnapshotter = TableSnapshotter;
//# sourceMappingURL=Snapshot.js.map